var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-status-user",class:[ _vm.computedStatus ]},[_vm._v("\n  "+_vm._s(_vm.$t(("users.statuses." + _vm.computedStatus)))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }